import {DateTime} from 'luxon'

import store from '@/store'
import {ActiveFormOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveForm'
import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import TextareaField from '@/components/Ui/ActiveForm/BZCore/Fields/TextareaField'
import NewsletersDateField from '@/components/Ui/ActiveForm/BZCore/Fields/NewsletterCalendarField'
import NewsletterRecipientsField from '@/components/Ui/ActiveForm/BZCore/Fields/NewsletterRecipientsField'

// @ts-ignore
import messages from '@/lang/index';

const createNewsletters: ActiveFormOptions = {
  label: messages.newsletters.new_newsletter,
  submitText: messages.labels.send,
  inputs: {
    title: {
      label: messages.labels.header,
      type: StringField,
      required: true
    },
    text: {
      label: messages.newsletters.text_for_newsletter,
      type: TextareaField,
      required: true,
      options: {
        rows: 8
      }
    },
    recipients: {
      label: messages.newsletters.steps.recipients,
      type: NewsletterRecipientsField,
      options: {}
    },
    date: {
      label: messages.newsletters.steps.date,
      type: NewsletersDateField,
      options: {}
    }
  },
  steps: [
    {
      map: [
        ['text']
      ]
    },
    {
      map: [
        ['recipients']
      ]
    },
    {
      map: [
        ['date']
      ]
    }
  ]
}

export default createNewsletters